import PressRoomLanding from './PressRoomLanding';
import schema from './props-schema';
import getEmptyDefaultProps from 'shared/lib/getEmptyDefaultProps';

PressRoomLanding.schema = schema;
PressRoomLanding.defaultProps = getEmptyDefaultProps(schema.templateSettings);

// https://github.com/webpack/webpack/issues/706
export default PressRoomLanding;
